export default __webpack_public_path__ + "3a5f806fc51fee6ce4ea655219cd63c7.svg";